import { action, makeAutoObservable, runInAction } from 'mobx';
import { execute } from '../apiCommandsExecutor';

export interface CallHistoryRecord {
    id: number;
    call_id: string;
    caller: string;
    callee: string;
    start_time: string;
    answer_time: string | null;
    end_time: string | null;
    duration: number | null;
    status: string;
    direction: string;
    recording_url: string | null;
    notes: string | null;
}

export interface CallHistoryFilters {
    skip: number;
    limit: number;
    status?: string;
    caller?: string;
    callee?: string;
    start_date?: string;
    end_date?: string;
}

interface CallHistoryResponse {
    calls: CallHistoryRecord[];
    total: number;
}

export class CallHistoryStore {
    calls: CallHistoryRecord[] = [];
    total: number = 0;
    loading: boolean = false;
    filters: CallHistoryFilters = {
        skip: 0,
        limit: 50
    };

    constructor() {
        makeAutoObservable(this);
    }

    @action
    setFilters(filters: Partial<CallHistoryFilters>) {
        this.filters = { ...this.filters, ...filters };
    }

    @action
    async fetchCalls() {
        try {
            this.loading = true;
            const params = new URLSearchParams({
                skip: this.filters.skip.toString(),
                limit: this.filters.limit.toString(),
            });

            if (this.filters.status) params.append('status', this.filters.status);
            if (this.filters.caller) params.append('caller', this.filters.caller);
            if (this.filters.callee) params.append('callee', this.filters.callee);
            if (this.filters.start_date) params.append('start_date', this.filters.start_date);
            if (this.filters.end_date) params.append('end_date', this.filters.end_date);

            const response = await execute<CallHistoryResponse>(`call-history?${params.toString()}`, {
                method: 'GET',
            });

            if (response) {
                runInAction(() => {
                    this.calls = response.calls;
                    this.total = response.total;
                });
            }
        } catch (error) {
            console.error('Ошибка при загрузке истории звонков:', error);
        } finally {
            runInAction(() => {
                this.loading = false;
            });
        }
    }
}

export default CallHistoryStore; 